"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/ConsentTab/TurnOffModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _consent = require('shared/services/consent');
var _smsDelivery = require('shared/services/smsDelivery');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);








const CONSENT_TURN_OFF_TITLE = 'Stop requiring consent?'

// Turning it off sends every waiting text; it says how many first.
const TurnOffModal = ({ isOpen, orgKey, onClose, onTurnedOff }) => {
  const [waiting, setWaiting] = _react.useState(null)
  const [isCounting, setIsCounting] = _react.useState.call(void 0, false)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [saveError, setSaveError] = _react.useState(null)

  _react.useEffect.call(void 0, () => {
    if (!isOpen) return undefined
    let isCurrent = true
    setWaiting(null)
    setSaveError(null)
    setIsCounting(true)
    _actions2.default.getOrgConsentWaiting({ OrgKey: orgKey })
      .then(r => { if (isCurrent) setWaiting(r.Messages) })
      // Without the count the dialog still says what happens.
      .catch(() => undefined)
      .finally(() => { if (isCurrent) setIsCounting(false) })
    return () => { isCurrent = false }
  }, [isOpen, orgKey])

  const turnOff = _react.useCallback.call(void 0, () => {
    setIsSaving(true)
    setSaveError(null)
    _actions2.default.turnOffOrgConsent({ OrgKey: orgKey })
      .then(onTurnedOff)
      .catch(e => setSaveError(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Couldn\'t turn this off. Try again.')))
      .finally(() => setIsSaving(false))
  }, [orgKey, onTurnedOff])

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, title: CONSENT_TURN_OFF_TITLE, size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        ,  isCounting ? 'Counting waiting messages…' : _consent.consentTurnOffCopy.call(void 0, waiting) 
      )
      ,  saveError && _react2.default.createElement('span', { role: "alert", className: "consent-turn-on-modal--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}},  saveError ) 
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Turn off" ,
        secondaryBtnLabel: "Cancel",
        isPrimaryLoading: isSaving,
        isPrimaryEnabled: !isSaving && !isCounting,
        onPrimaryBtnClick: turnOff,
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
      )
    )
  )
}

exports. default = TurnOffModal
